import { createRequestActionTypes } from "../../../shared/utility";

export const StoreActions = {
    fetchStoreMetadata: createRequestActionTypes('FETCH_STORE_METADATA'),
    fetchStoreDetails: createRequestActionTypes('FETCH_STORE_DETAILS'),
    createStoreDetails: createRequestActionTypes('CREATE_NEW_STORE')
}